import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from '@material-ui/core'
import Description from '@mui/icons-material/Description'
import { useEffect, useState } from 'react'
import useAxiosPrivate from '../../../hooks/useAxiosPrivate'

export const ADF = (props) => {
  const { coproprietaire, only_last = false, key } = props
  const [documents, setDocuments] = useState([])
  const middleofficeRequest = useAxiosPrivate()
  const fetchData = async () => {
    try {
      const res = await middleofficeRequest.get(
        `middleoffice/coowners/${coproprietaire.id}/documents`
      )
      const { data } = res
      var docs = Object.keys(data)
        .filter((k) => {
          return data[k]?.type === 'ADF' || data[k]?.tags?.includes('ADF')
        })
        .map((key) => data[key])

      docs.reverse()

      if (only_last == true) docs = [docs[0]]
      setDocuments(() => {
        return docs
      })
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [key, coproprietaire])

  return (
    <Box component={Paper} key={key} padding={'20px'}>
      <List dense={true} component="nav">
        {documents &&
          documents.map((doc) => {
            return (
              doc && (
                <ListItem
                  key={doc.url}
                  component="a"
                  target="_blank"
                  href={doc.url}
                  rel="noreferrer"
                  button
                >
                  <ListItemIcon>
                    <Description />
                  </ListItemIcon>
                  <ListItemText primary={doc.libelle} />
                </ListItem>
              )
            )
          })}
      </List>
    </Box>
  )
}
export default ADF
